var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.17956C0 12.8695 4.72752 15.901 8.18731 18.6155C9.408 19.5726 10.584 20.4747 11.76 20.4747C12.936 20.4747 14.112 19.5738 15.3327 18.6143C18.7937 15.9022 23.52 12.8695 23.52 7.18073C23.52 1.49084 17.052 -2.54463 11.76 2.92647C6.468 -2.5458 0 1.48967 0 7.17956Z",
    fill: "#EC5569"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heartIcon.513b96a0b4e9923955678db639602a8c.svg";
export { ForwardRef as ReactComponent };